const data = [
  {
    offset: 0,
    project: "Software Engineering (CZ2006): Parkere",
    title: "Frontend Developer",
    description:
      "A carpark info mobile application that gives you all the needed information about a carpark!",
    works: [
      "Planned and designed the architecture, workflow, and database system of a carpark info mobile application which was built on React Native, Express.js, and PostgreSQL",
      "Implemented a map to easily navigate through carparks using Google Map’s API and Redux",
      "Utilized Google Login and JWT authentication to have access on reviewing carpark",
      "Deployed the backend server through Huawei Cloud",
    ],
  },
  {
    offset: 1,
    project: "GTD POLOG Project",
    title: "Frontend and Backend Developer",
    description:
      "A booking system and payment website to play a series of games made by Project Officers and Logistics!",
    works: [
      "Liaised with Project Officers to plan and develop an online booking and payment system website which was built on React.js, Express.js, MongoDB for a series of exciting games",
      "Achieved a total of 160 participants and obtained a profit of around S$1250",
    ],
  },
  {
    offset: 2,
    project: "PINTU Apps",
    title: "Backend Developer",
    description: "A web application for the community of Indonesians in NTU.",
    works: [
      "Develop a web-based application as a backend developer utilizing Django (Python)",
      "Created the user models and endpoints using JWT Authentication to be able to have access around the page, an email OTP when registering to validate it is an NTU email, and permission classes for buyer and seller endpoints",
      "Implemented Agile methodology and practices on ClickUp",
    ],
  },
  {
    offset: 3,
    project: "Trace The Clues",
    title: "Frontend Developer",
    description:
      "A web-based game where you are given hexagon tiles consisting a bunch of activities for you to conquer!",
    works: [
      "Planned and develop a web-based game which was built on React.js, Express.js, MongoDB",
      "Implemented three segments for the website, a home page to see the leaderboard and navigation, the game itself, and a view page to look at the progress of other teams",
      "Utilized Web Socket to sync player input on game and view page to obtain live updates on each team’s progress",
    ],
  },
  {
    offset: 4,
    project:
      "Object Oriented Programming (CZ2002): Restaurant Reservation and Points of Sale System (RRPSS)",
    title: "Java Developer",
    description:
      "An application to computerize the process of making reservation, recording of orders, and displaying of sale records",
    works: [
      "Planned a reservation system for a restaurant using Java 8",
      "Utilized .ser / .txt file as the database by using File and Object read and write built in function by Java",
      "Implemented an MVC (Model, View, Controller) design, Polymorphism, Inheritance, and Encapsulation",
    ],
  },
  {
    offset: 5,
    project: "PINTU Website",
    title: "Frontend Developer",
    description: "A personal website for PINTU",
    works: [
      "Revamped the whole web page to boost user experience and improve user interface with the help of React.js and CSS",
      "Programmed the whole home page with zero knowledge about JavaScript",
    ],
  },
];

export default data;
